import { Typography, Button } from "@mui/material";
import { tss } from "tss-react";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import {
    SliceManual,
    SliceSide,
    SliceFront,
    SliceHor,
    SliceNone,
    SliceAll,
    SliceFrontBackward,
    SliceFrontForward,
    SliceHorBottom,
    SliceHorTop,
    SliceSideLeft,
    SliceSideRight,
} from "assets/images/index";

const useStyles = tss.create({
    header: {
        height: 30,
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
    },
    topIcon: {
        color: "rgb(170,170,170)",
    },
    icon: {
        position: "relative",
        width: 24,
        height: 24,
        minWidth: 24,
        verticalAlign: "middle",
        display: "inline-block",
    },
    iconPadding: {
        marginLeft: 18,
    },
    title: {
        display: "inline-block",
        position: "relative",
        fontWeight: 400,
        fontSize: 14,
        left: 10,
    },
    button: {
        width: 30,
        height: 30,
        minWidth: 30,
    },
    selected: {
        backgroundColor: "rgb(235,238,244)",
    },
    container: {
        display: "grid",
        gridTemplateColumns: "auto auto auto auto",
        padding: 10,
    },
    item: {
        padding: 10,
        textAlign: "center",
        width: 50,
    },
});

export default function SliceContainer(props: { presetSelected: number; handleClick: (preset: number) => void }) {
    const { classes } = useStyles();
    const { presetSelected, handleClick } = props;

    return (
        <div id="sliceContainer" className={classes.container}>
            <div className={classes.item}>
                <Button
                    id={"preset-1"}
                    className={presetSelected === 1 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 1 ? "outlined" : "text"}
                    onClick={(e) => handleClick(1)}
                >
                    <SliceIcon preset={1} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-2"}
                    className={presetSelected === 2 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 2 ? "outlined" : "text"}
                    onClick={(e) => handleClick(2)}
                >
                    <SliceIcon preset={2} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-3"}
                    className={presetSelected === 3 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 3 ? "outlined" : "text"}
                    onClick={(e) => handleClick(3)}
                >
                    <SliceIcon preset={3} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-4"}
                    className={presetSelected === 4 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 4 ? "outlined" : "text"}
                    onClick={(e) => handleClick(4)}
                >
                    <SliceIcon preset={4} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-5"}
                    className={presetSelected === 5 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 5 ? "outlined" : "text"}
                    onClick={(e) => handleClick(5)}
                >
                    <SliceNone className={classes.icon} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-6"}
                    className={presetSelected === 6 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 6 ? "outlined" : "text"}
                    onClick={(e) => handleClick(6)}
                >
                    <SliceIcon preset={6} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-7"}
                    className={presetSelected === 7 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 7 ? "outlined" : "text"}
                    onClick={(e) => handleClick(7)}
                >
                    <SliceIcon preset={7} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-8"}
                    className={presetSelected === 8 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 8 ? "outlined" : "text"}
                    onClick={(e) => handleClick(8)}
                >
                    <SliceIcon preset={8} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-9"}
                    className={presetSelected === 9 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 9 ? "outlined" : "text"}
                    onClick={(e) => handleClick(9)}
                >
                    <SliceIcon preset={9} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-10"}
                    className={presetSelected === 10 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 10 ? "outlined" : "text"}
                    onClick={(e) => handleClick(10)}
                >
                    <SliceIcon preset={10} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-11"}
                    className={presetSelected === 11 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 11 ? "outlined" : "text"}
                    onClick={(e) => handleClick(11)}
                >
                    <SliceIcon preset={11} />
                </Button>
            </div>
            <div className={classes.item}>
                <Button
                    id={"preset-12"}
                    className={presetSelected === 12 ? [classes.button, classes.selected].join(" ") : classes.button}
                    variant={presetSelected === 12 ? "outlined" : "text"}
                    onClick={(e) => handleClick(12)}
                >
                    <SliceIcon preset={12} />
                </Button>
            </div>
        </div>
    );
}
export function SliceIcon(props: { preset: number }) {
    const { classes } = useStyles();
    switch (props.preset) {
        case 1:
            return <SliceManual className={classes.icon} />;
        case 2:
            return <SliceSide className={classes.icon} />;
        case 3:
            return <SliceFront className={classes.icon} />;
        case 4:
            return <SliceHor className={classes.icon} />;
        case 6:
            return <SliceSideLeft className={classes.icon} />;
        case 7:
            return <SliceFrontBackward className={classes.icon} />;
        case 8:
            return <SliceHorTop className={classes.icon} />;
        case 9:
            return <SliceAll className={classes.icon} />;
        case 10:
            return <SliceSideRight className={classes.icon} />;
        case 11:
            return <SliceFrontForward className={classes.icon} />;
        case 12:
            return <SliceHorBottom className={classes.icon} />;
        default:
            return <div />;
    }
}

export function SliceHeader(props: { preset: number; collapse: boolean; toggleHeader: () => void }) {
    const { classes, cx } = useStyles();
    let title = "";
    let showButon = false;
    const { preset } = props;

    if (preset === 5) {
        title = "Choose a Cross-section mode";
    } else if (preset === 9) {
        title = "All Axis";
        showButon = true;
    } else {
        title = "Cross-section";
        showButon = true;
    }

    return (
        <div className={classes.header}>
            <div className={classes.iconPadding}>
                <SliceIcon preset={preset} />
            </div>
            <Typography className={classes.title}> {title}</Typography>
            <div style={{ display: showButon ? "inline-block" : "none", marginLeft: 5 }}>
                <Button className={classes.button} variant={"text"} onClick={props.toggleHeader}>
                    {props.collapse ? (
                        <ArrowDropDown className={cx(classes.icon, classes.iconPadding)} />
                    ) : (
                        <ArrowDropUp className={cx(classes.icon, classes.iconPadding)} />
                    )}
                </Button>
            </div>
        </div>
    );
}
